// extracted by mini-css-extract-plugin
module.exports = {"notice":"styles_notice__2RytV","vertical":"styles_vertical__3NcPm","body":"styles_body__1lmn6"};